/**
 * contactOpenIntent — preview, or the full record? — Card P95 item 2.
 *
 * ⛔⛔ A MODIFIER-CLICK MEANS "SOMEWHERE ELSE, AND LEAVE ME WHERE I AM".
 * Every browser has taught people that cmd/ctrl-click opens a thing elsewhere
 * without moving them. A slide-over is NOT somewhere else — it is on top of
 * where they already are — so honouring the gesture means opening the full
 * record in its own CRM tab, exactly as the board did before this card.
 *
 * ⚠ SHIFT AND MIDDLE-CLICK COUNT TOO. People reach for whichever of the three
 * their habits give them, and all three mean the same thing here. Accepting
 * only cmd/ctrl would make the feature work for some reps and not others, in
 * a way neither group could describe.
 *
 * Pure, and separate from CRMPage, so the rule can be read and tested without
 * mounting the whole CRM.
 */

/**
 * @param {object} [event] a React or DOM mouse event
 * @returns {'full'|'preview'}
 */
export function contactOpenIntent(event) {
  if (!event) return 'preview';
  // ⚠ `button === 1` is the middle button; it is 0 for a normal left click,
  // and `undefined` on a synthetic event, which must NOT read as middle.
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return 'full';
  return 'preview';
}

export default contactOpenIntent;
